import React from 'react';

import ErrorBoundary from './error-boundary';

/* yup extension, must be imported before the main application */
import '~c/helpers/yup-extended';

// Old v1 code
// import App from '~c/v1/containers/App';
import { App } from '~c/components/app';

import 'normalize.css/normalize.css';

interface Props {}

const AppWrapper: React.FC<Props> = () => {
  return (
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
};

export default AppWrapper;
